import { ProtectedJsonAPI } from '.'

export const ActivityLogItems = ProtectedJsonAPI.extend(
  '',
  {
    index: endpoint => endpoint.method('get').path(({dealSheetId}) => `deal_sheets/${dealSheetId}/activity_log_items`),
  }
)